import { render, staticRenderFns } from "./PersonalGrids.vue?vue&type=template&id=12041bc2&scoped=true&"
import script from "./PersonalGrids.vue?vue&type=script&lang=js&"
export * from "./PersonalGrids.vue?vue&type=script&lang=js&"
import style0 from "./PersonalGrids.vue?vue&type=style&index=0&id=12041bc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12041bc2",
  null
  
)

export default component.exports